import * as React from 'react'
import { Grid } from 'semantic-ui-react'

import withSkippable from '../../enhancers/skippable'
import { NumberField } from '../formfields'
import Constants from '../../utils/constants'
import { CommentItemToggleableHook } from '../../enhancers/toggleable'
import { getSummaryExpression } from '../../utils/summary-helpers'

import HTMLText from '../system-wide/html-text'

const numberFieldStyle = { marginTop: '0.3rem' }

// ROUND: Number(Math.round(value + 'e' + decimals) + 'e-' + decimals)
const Summary = props => {
  const textStyle = { opacity: props.disabled ? '0.45' : '1' }
  return (
    <Grid.Row className="rs-grid-container-fluid resurvey question body">
      <Grid.Column {...Constants.getWidths(props.labelWidth)} style={numberFieldStyle}>
        <span style={textStyle}>
          <HTMLText value={props.label} />
        </span>
      </Grid.Column>
      <Grid.Column {...Constants.getWidths(props.inputWidth)} style={numberFieldStyle}>
        <span style={textStyle}>
          <HTMLText value={getSummaryExpression(props.type, props.format, props.tokens)} />
        </span>
      </Grid.Column>
    </Grid.Row>
  )
}

class NumberQuestionBody extends React.PureComponent {
  static defaultProps = {
    items: [],
    options: {},
  }

  render() {
    let questionWidth = this.props.options.width || Constants.FULLWIDTH
    let { labelWidth, inputWidth } = Constants.getDefaultFieldWidths(questionWidth)

    let summaryTokens = this.props.items.reduce((acc, item) => {
      return [...acc, `${this.props.currentPageName}.${this.props.name}.${item.key}`]
    }, [])

    let summaries = []
    if (typeof this.props.options.sum !== 'undefined') summaries.push('sum')
    if (typeof this.props.options.prod !== 'undefined') summaries.push('prod')
    if (typeof this.props.options.avg !== 'undefined') summaries.push('avg')

    let numbers = this.props.items.map(r => {
      return (
        <Grid.Row key={r.key} className="rs-grid-container-fluid resurvey question body">
          <NumberField
            name={r.key}
            hasComment={r.has_comment}
            questionWidth={this.props.options.width || Constants.FULLWIDTH}
            label={r.value}
            min={this.props.options.min || Constants.DEFAULTS.NUMBER_MIN}
            max={this.props.options.max || Constants.DEFAULTS.NUMBER_MAX}
            suffix={this.props.options.suffix || ''}
            prefix={this.props.options.prefix || ''}
            parentDisabled={this.props.disabled}
            jsonref={r.jsonref}
            key={`item-${r.jsonref}`}
            questionName={this.props.name}
            currentPageName={this.props.currentPageName}
            format={this.props.options.format || Constants.DEFAULTS.NUMBER_FORMAT}
            questionSkipped={this.props.questionSkipped}
          />
          {r.has_comment && (
            <CommentItemToggleableHook
              currentPageName={this.props.currentPageName}
              questionName={this.props.name}
              name={r.key + '_comment'}
              jsonref={r.jsonref + '_comment'}
            />
          )}
        </Grid.Row>
      )
    })

    if (this.props.reverseItems) numbers.reverse()

    return (
      <React.Fragment>
        {numbers}

        {summaries.map(type => (
          <Summary
            key={type}
            disabled={this.props.disabled || this.props.questionSkipped || false}
            label={this.props.options[type] || ''}
            format={this.props.options.format || '00000'}
            tokens={summaryTokens}
            labelWidth={labelWidth}
            inputWidth={inputWidth}
            type={type}
          />
        ))}
      </React.Fragment>
    )
  }
}

export default withSkippable(NumberQuestionBody)
